import { useParams } from "react-router-dom";
import { BreadcrumbItem } from "../../../components/common/breadcrumbs/Breadcrumbs";
import { useDealer } from "../../../hooks/useDealer";
import { HeaderPage } from "../../../components/header-page/HeaderPage";

const breadcrumbItems: BreadcrumbItem[] = [
  { label: "Dsitribuidores", href: "/dashboard/distributors" },
  { label: "Historial de Precios Especiales Por Distribuidor" },
];

type DistributorSpecialPriceHeaderProps = {
  onNewPriceHistory: () => void;
};

export const DistributorSpecialPriceHeader = (
  props: DistributorSpecialPriceHeaderProps,
) => {
  const { onNewPriceHistory } = props;
  const { distributorId = "" } = useParams();
  const { data: distributorData, isLoading } = useDealer({
    dealerId: distributorId,
  });

  const handleNewPriceHistory = () => {
    onNewPriceHistory();
  };

  return (
    <HeaderPage
      title="Historial de Precios Especiales Por Distribuidor"
      subTitle={distributorData?.name || ""}
      breadcrumbItems={breadcrumbItems}
      onNew={handleNewPriceHistory}
    />
  );
};
